import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "text-truncate" }
const _hoisted_2 = { class: "text-truncate" }
const _hoisted_3 = { class: "text-truncate" }
const _hoisted_4 = { class: "text-truncate" }
const _hoisted_5 = { class: "text-truncate" }
const _hoisted_6 = { class: "text-truncate" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-edit" }, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1)
const _hoisted_12 = [
  _hoisted_11
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_VZSideDrawer = _resolveComponent("VZSideDrawer")!
  const _component_VZDeleteModal = _resolveComponent("VZDeleteModal")!
  const _component_ActivityModal = _resolveComponent("ActivityModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Datatable, {
      "table-data": _ctx.tableData,
      "table-header": _ctx.tableHeader,
      total: _ctx.total,
      rowsPerPage: _ctx.rowsPerPage,
      page: _ctx.page,
      loading: _ctx.loading,
      showSearch: _ctx.showSearch,
      defaultFilter: _ctx.defaultFilter,
      tableFilter: _ctx.tableFilter,
      bulkDelete: _ctx.bulkDelete,
      tableForm: _ctx.computedFormModel,
      addButtonText: `${_ctx.t('pages.site.addDevice')}`,
      viewName: "devices",
      activityTab: false,
      onQueryUpdate: _ctx.syncQuery,
      onTableRowClick: _ctx.tableRowClick,
      onFormSubmit: _ctx.submit,
      onFormCancel: _ctx.formCancel,
      permissions: _ctx.permissionModel,
      ref: "datatable"
    }, {
      "cell-name": _withCtx(({ row: site }) => [
        _createElementVNode("span", _hoisted_1, _toDisplayString(site.name), 1)
      ]),
      "cell-siteName": _withCtx(({ row: site }) => [
        _createElementVNode("span", _hoisted_2, _toDisplayString(site.siteDevices[0].site_name), 1)
      ]),
      "cell-locationName": _withCtx(({ row: site }) => [
        _createElementVNode("span", _hoisted_3, _toDisplayString(site.locationName), 1)
      ]),
      "cell-typeTextCode": _withCtx(({ row: site }) => [
        _createElementVNode("span", _hoisted_4, _toDisplayString(site.typeTextCode), 1)
      ]),
      "cell-uuId": _withCtx(({ row: site }) => [
        _createElementVNode("span", _hoisted_5, _toDisplayString(site.uuId), 1)
      ]),
      "cell-macAddress": _withCtx(({ row: site }) => [
        _createElementVNode("span", _hoisted_6, _toDisplayString(site.macAddress), 1)
      ]),
      "cell-status": _withCtx(({ row: site }) => [
        _createElementVNode("span", {
          class: _normalizeClass(["text-truncate fw-bolder", {
          'badge badge-success': site.status?.toLowerCase() === 'active',
          'badge badge-danger': site.status?.toLowerCase() !== 'active',
        }])
        }, _toDisplayString(_ctx.format.TitleCase(site.status?.toLowerCase())), 3)
      ]),
      "cell-siteDeviceStatus": _withCtx(({ row: site }) => [
        _createElementVNode("span", {
          class: _normalizeClass(["text-truncate fw-bolder", {
          'badge badge-success':
            site.siteLocationDeviceModels[0].siteDeviceStatus?.toLowerCase() ===
            'active',
          'badge badge-danger':
            site.siteLocationDeviceModels[0].siteDeviceStatus?.toLowerCase() !==
            'active',
        }])
        }, _toDisplayString(_ctx.format.TitleCase(
            site.siteLocationDeviceModels[0].siteDeviceStatus?.toLowerCase()
          )), 3)
      ]),
      "cell-locationStatus": _withCtx(({ row: site }) => [
        _createElementVNode("span", {
          class: _normalizeClass(["text-truncate fw-bolder", {
          'badge badge-success':
            site.siteLocationDeviceModels[0].locationStatus?.toLowerCase() ===
            'active',
          'badge badge-danger':
            site.siteLocationDeviceModels[0].locationStatus?.toLowerCase() !==
            'active',
        }])
        }, _toDisplayString(_ctx.format.TitleCase(
            site.siteLocationDeviceModels[0].locationStatus?.toLowerCase()
          )), 3)
      ]),
      "cell-actions": _withCtx(({ row: site }) => [
        (_ctx.hasPermission(_ctx.permissionModel.update))
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              onClick: _withModifiers(($event: any) => (_ctx.editSite(site)), ["stop"]),
              "data-bs-toggle": "modal",
              "data-bs-target": "#vz-add-edit-modal-devices",
              class: "btn btn-icon btn-primary btn-circle btn-sm"
            }, _hoisted_9, 8, _hoisted_7))
          : _createCommentVNode("", true),
        (_ctx.hasPermission(_ctx.permissionModel.delete))
          ? (_openBlock(), _createElementBlock("a", {
              key: 1,
              onClick: _withModifiers(
          () => {
            _ctx.showDeleteDialog = true;
            _ctx.selectedForAction = site;
          }
        , ["stop"]),
              class: "btn btn-icon btn-danger btn-circle btn-sm ms-3"
            }, _hoisted_12, 8, _hoisted_10))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["table-data", "table-header", "total", "rowsPerPage", "page", "loading", "showSearch", "defaultFilter", "tableFilter", "bulkDelete", "tableForm", "addButtonText", "onQueryUpdate", "onTableRowClick", "onFormSubmit", "onFormCancel", "permissions"]),
    _createVNode(_component_VZSideDrawer, {
      modelValue: _ctx.openDrawer,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.openDrawer) = $event)),
      title: _ctx.sideDrawerTitle,
      icon: _ctx.sideDrawerIcon,
      onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openDrawer = false)),
      tabs: _ctx.tabs
    }, null, 8, ["modelValue", "title", "icon", "tabs"]),
    (_ctx.hasPermission(_ctx.permissionModel.delete))
      ? (_openBlock(), _createBlock(_component_VZDeleteModal, {
          key: 0,
          showDialog: _ctx.showDeleteDialog,
          viewName: "devices",
          pageName: "device",
          selectedForAction: [_ctx.selectedForAction.webId],
          deleteText: `${_ctx.t('validation.sureToDelete')} ${_ctx.selectedForAction.name}?`,
          onClose: _ctx.refreshList
        }, null, 8, ["showDialog", "selectedForAction", "deleteText", "onClose"]))
      : _createCommentVNode("", true),
    _createVNode(_component_ActivityModal, {
      refresh: _ctx.loading,
      icon: "bi bi-cpu fs-3",
      viewName: "Devices Activity Pulse",
      type: "400,1500"
    }, null, 8, ["refresh"])
  ], 64))
}